import { render, staticRenderFns } from "./basereporteprospectos.vue?vue&type=template&id=74017e87"
import script from "./basereporteprospectos.vue?vue&type=script&lang=js"
export * from "./basereporteprospectos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports